module.exports = __webpack_public_path__ + "img/mychoice.89bf54bf.jpg";